@if ($call()) {
  <div class="dialog _call" [style.width]="$callWidth()">
    <div class="dialog__header">
      <div class="dialog__title">SOS</div>
    </div>
    <div class="dialog__content">
      <app-device-call [deviceId]="data.deviceId" [deviceName]="deviceName" responsive (closeClicked)="close()" />
    </div>
    <div class="dialog__footer">
      <button type="button" app-flat-button color="warn" mat-dialog-close>Закрыть</button>
      <a app-flat-button color="secondary" [routerLink]="['/monitoring', data.deviceId]" mat-dialog-close>
        К устройству
      </a>
    </div>
  </div>
} @else {
  <div class="dialog" [class._disabled]="$interactionDisabled()">
    <div class="dialog__header">
      <div class="dialog__title">SOS</div>
    </div>
    <div class="dialog__content">
      <p>Получен SOS сигнал от устройства {{ deviceName }}.</p>
    </div>
    <div class="dialog__footer">
      <button type="button" app-flat-button color="warn" mat-dialog-close>Отмена</button>
      <a app-flat-button color="secondary" [routerLink]="['/monitoring', data.deviceId]" mat-dialog-close>
        К устройству
      </a>
      <button type="button" app-flat-button color="primary" (click)="startCall()">Звонок</button>
    </div>
  </div>
}
